<div style="text-align: center;">
  <span class="spin-cont">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="message">{{message}}</p>
  </span>
</div>
